import api from './api';

export const getStats = async () => {
  const response = await api.get('/admin/stats');
  return response.data;
};

export const getCompanySettings = async () => {
  const response = await api.get('/admin/settings');
  return response.data;
};

export const updateCompanySettings = async (settings) => {
  const response = await api.post('/admin/settings', settings);
  return response.data;
};

export const getInvitations = async (status) => {
  const url = status && status !== 'all' ? `/admin/invitations?status=${status}` : '/admin/invitations';
  const response = await api.get(url);
  return response.data;
};

export const createInvitation = async (invitationData) => {
  const response = await api.post('/admin/invitations', invitationData);
  return response.data;
};

export const importUsersFromCSV = async (file) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await api.post('/admin/users/import', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const exportUsersToCSV = async () => {
  const response = await api.get('/admin/users/export', {
    responseType: 'blob',
  });

  // Create download link
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'users_export.csv');
  document.body.appendChild(link);
  link.click();
  link.remove();

  return true;
};

export const downloadImportTemplate = async () => {
  const response = await api.get('/admin/users/import/template', {
    responseType: 'blob',
  });

  // Create download link
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'user_import_template.csv');
  document.body.appendChild(link);
  link.click();
  link.remove();

  return true;
};

export const discoverSlackUsers = async () => {
  const response = await api.get('/admin/users/discover-slack');
  return response.data;
};

export const importSlackUsers = async (selectedUsers) => {
  const response = await api.post('/admin/users/import-from-slack', selectedUsers);
  return response.data;
};

export const updateUserRole = async (userId, role) => {
  const response = await api.post(`/admin/users/${userId}/role?role=${role}`);
  return response.data;
};

export const updateUserEmailMarketing = async (userId, enabled) => {
  const response = await api.post(`/admin/users/${userId}/email-marketing?enabled=${enabled}`);
  return response.data;
};